import React, { useEffect, useState } from 'react';
import { ContainerPasswordVerification } from './styles';

import {
  passwordHasNumber,
  passwordhasMoreThanEightCharacters,
  passwordHasUpperCaseAndLowerCase,
  passwordHasSequenceNumbers,
} from '../../Utils/validatePassword';

const PasswordVerification = ({ password, setApproved }) => {
  const [isValid, setIsValid] = useState({
    passwordhasMoreThanEightCharacters: false,
    passwordHasNumber: false,
    passwordHasUpperCaseAndLowerCase: false,
    passwordHasSequenceNumbers: false,
  });

  const verifyIfPasswordIsValid = (values) => {
    let isPasswordValid = true;
    for (const obj of Object.entries(values)) {
      if (obj[1] === false) {
        isPasswordValid = false;
        break;
      }
    }

    return isPasswordValid;
  };

  const handleErrorStyleClass = (valid) => {
    if (password && !valid) {
      return 'errorValidation';
    }
  };

  const validatePasswordItems = () => {
    const values = {
      passwordhasMoreThanEightCharacters:
        passwordhasMoreThanEightCharacters(password),
      passwordHasNumber: passwordHasNumber(password),
      passwordHasUpperCaseAndLowerCase:
        passwordHasUpperCaseAndLowerCase(password),
      passwordHasSequenceNumbers: passwordHasSequenceNumbers(password),
    };
    setIsValid(values);

    const isPasswordValid = verifyIfPasswordIsValid(values);
    setApproved(isPasswordValid);
  };

  useEffect(() => {
    validatePasswordItems();
  }, [password]);

  return (
    <ContainerPasswordVerification>
      <span className='title'>
        A sua nova senha deve seguir as regras abaixo:
      </span>
      <div className='container-rules'>
        <label
          className={handleErrorStyleClass(
            isValid.passwordhasMoreThanEightCharacters
          )}
        >
          <input
            type='checkbox'
            checked={isValid.passwordhasMoreThanEightCharacters}
          />
          Pelo menos 8 caracteres
        </label>
        <label className={handleErrorStyleClass(isValid.passwordHasNumber)}>
          <input type='checkbox' checked={isValid.passwordHasNumber} />
          Pelo menos 1 número
        </label>
        <label
          className={handleErrorStyleClass(
            isValid.passwordHasUpperCaseAndLowerCase
          )}
        >
          <input
            type='checkbox'
            checked={isValid.passwordHasUpperCaseAndLowerCase}
          />
          Pelo menos 1 letra minúscula e 1 maiúscula
        </label>
        <label
          className={handleErrorStyleClass(isValid.passwordHasSequenceNumbers)}
        >
          <input type='checkbox' checked={isValid.passwordHasSequenceNumbers} />
          Não deve seguir algum tipo de sequência
        </label>
      </div>
    </ContainerPasswordVerification>
  );
};

export default PasswordVerification;
